module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingSave),
      expression: "loadingSave",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": 'Processando...' + (_vm.requestParam.uploadProgress != null ? '\n' + _vm.requestParam.uploadProgress + '%' : '')
    }
  }, [_c('ed-modal', {
    attrs: {
      "title": this.$store.state.ltcat.title + 'Gerar Novo Orçamento',
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.loadingSave,
      "onSave": _vm.salvar,
      "width": "80%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.exameItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc809c5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/orcamento/cadastrar.vue
// module id = 1589
// module chunks = 45